import React from 'react';
import { T, tintFor, initialsOf } from './login.theme';
import { CloseIcon } from './LoginIcons';

/**
 * One waiter's tile.
 *
 * Four states, and the destructive one is not among the first three: removing
 * a tile is only reachable in Manage mode, never a stray click away from
 * signing in.
 */
export default function WaiterTile({ profile, onOpen, onRemove, managing }) {
  const [hovered, setHovered] = React.useState(false);
  const [focused, setFocused] = React.useState(false);

  const tint = tintFor(profile);
  const lit = !managing && (hovered || focused);

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={managing ? `Remove ${profile.name}` : `Sign in as ${profile.name}`}
      onClick={() => (managing ? onRemove(profile) : onOpen(profile))}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (managing) onRemove(profile);
          else onOpen(profile);
        }
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        padding: 14,
        background: lit ? T.selectedBg : T.surface,
        border: `1px solid ${
          managing ? T.dangerBorder : lit ? T.selectedBorder : T.border
        }`,
        borderRadius: T.radiusPanel,
        boxShadow: focused && !managing ? `0 0 0 3px ${T.brandTint}` : 'none',
        cursor: 'pointer',
        outline: 'none',
        boxSizing: 'border-box',
      }}
    >
      {managing ? (
        <span
          style={{
            position: 'absolute',
            right: 9,
            top: 9,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 26,
            height: 26,
            background: T.dangerTint,
            border: `1px solid ${T.dangerBorder}`,
            borderRadius: 7,
            color: T.danger,
          }}
        >
          <CloseIcon size={13} width={2.3} />
        </span>
      ) : null}

      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 44,
          height: 44,
          borderRadius: T.radiusPill,
          background: managing ? T.canceledTint : tint.bg,
          fontSize: 15,
          fontWeight: 700,
          color: managing ? T.inkFaint : tint.ink,
        }}
      >
        {initialsOf(profile.name || profile.username)}
      </span>

      <span style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
        <span
          style={{
            fontSize: 13.5,
            fontWeight: 600,
            color: managing ? T.inkSoft : T.ink,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {profile.name || profile.username}
        </span>
        <span
          style={{
            fontSize: 11.5,
            color: T.inkFaint,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {profile.username}
        </span>
      </span>
    </div>
  );
}
